import React from "react";
import { Navigate } from "react-router-dom";

interface Props {
  children: React.ReactNode;
}

const RequireCognitoFlow: React.FC<Props> = ({ children }) => {
  const isFlowActive = sessionStorage.getItem("cognito_flow_active");

  if (!isFlowActive) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default RequireCognitoFlow;